import React from "react";
import { withStyles, withTheme } from "@material-ui/core/styles";
import { InlineTimePicker, InlineDatePicker, InlineDateTimePicker } from 'material-ui-pickers';
import { compose } from "recompose";
import ArrowLeft from '@material-ui/icons/ChevronLeft';
import ArrowRight from '@material-ui/icons/ChevronRight';
import DateRange from '@material-ui/icons/DateRange';
import Time from '@material-ui/icons/AccessTime';
import Clear from '@material-ui/icons/CancelOutlined';
import InputAdornment from '@material-ui/core/InputAdornment';
import appConstants from "../../../../appConstants";
import { isValid as isDateTimeValid,parse,format} from "date-fns";

const styles = theme => ({
    container:{
        backgroundColor: theme.ModalBGColor,
        minHeight: "50px",
        display: "flex",
        flexDirection:"row",
        maxWidth: "260px",
        '&>div':{
            margin: "5px"
        },
        '& $inputRoot input$inputStyle[type="text"]':{
            fontSize: theme.textFontSize,
            color: theme.TextColor,
            border: "none",
            height: 24,
            '&:focus':{
                border:"none"
            },
            '&::placeholder':{
                color: "currentColor",
            }
        },
        // '& [class*="MuiPickersCalendarHeader-iconButton"] span,& div[class*="MuiPickersSlideTransition-transitionContainer"] > *,& span[class*="MuiPickersClockNumber-clockNumber"],& button[class*="MuiPickersDay-day"]':{
        //     color: theme.TextColor
        // },
        // '& [class*="MuiPickersCalendarHeader-iconButton"],& [class*="MuiPickersCalendarHeader-iconButton"] span':{
        //     backgroundColor: "transparent"
        // },
        // '& span[class*="MuiPickersCalendarHeader-dayLabel"]':{
        //     color: theme.HeaderDefaultTextColor
        // },
        // '& span[class*="MuiPrivateTabIndicator-root"]':{
        //     backgroundColor: theme.iconColor
        // },
        // '& button[class*="MuiPickersDay-disabled"],& button[class*="MuiIconButton-disabled"]':{
        //     opacity: 0.4
        // },
        // '& button[class*="MuiPickersDay-hidden"]':{
        //     opacity: 0
        // },
        // '& div[class*="MuiPickersYear-root"]':{
        //     color: theme.TextColor,
        //     '&[class*="MuiPickersYear-selected"]':{
        //         color: theme.HeaderSelectedText
        //     }
        // },
        // '& p[class*="MuiFormHelperText-root"][class*="MuiFormHelperText-error"]':{
        //     backgroundColor: theme.ModalBGColor,
        //     marginTop:0,
        //     paddingTop:8
        // }
    },
    horizontalView:{
        border: `1px solid ${theme.iconColor}`,
        minHeight: 30,
        maxWidth: 330,
        display: "flex",
        marginTop: -4,
        paddingTop: 2,
        alignItems: "center",
        '& $inputRoot':{
            marginTop:0
        },
        '&$container >div':{
            margin: "0px 5px"
        },
        '& $labelProps':{
            marginTop: -16,
        },
        '& $labelShrink':{
            marginTop:-2
        },
        '& $inputRoot input$inputStyle[type="text"]':{
            paddingBottom:0
        },
        '& $inputAdornment':{
            marginTop:6
        }
    },
    dateTimeContainer:{
        maxWidth: "135px",
        flexDirection:"column",
    },
    timeContainer:{
        maxWidth: "180px",
    },
    paperStyle:{
        backgroundColor: theme.ModalBGColor,
        color:theme.TextColor
    },
    labelProps:{
        fontSize: theme.textFontSize,
        color:theme.iconColor,
    },
    labelShrink:{

    },
    inputStyle:{
        fontSize: theme.textFontSize,
        color:theme.TextColor,
    },
    inputRoot:{
        fontSize: theme.textFontSize,
        color:theme.TextColor,
        borderBottom: `1px solid ${theme.iconColor}`,
        '&::before, &::after':{
            border: "none !important"
        },
        '&$inputFocus':{
            borderBottom: `2px solid ${theme.HeaderSelectedText}`,
        }
    },
    inputFocus:{
    },
    iconColor:{
        color: theme.iconColor
    },
    inputAdornment:{
        cursor: "pointer",
    },
    helperText:{
        margin:0,
        paddingTop:8,
        backgroundColor: theme.ComponentHeader,
    }
});



const DateTimeRange = props => {
    const dateTypeFormat = props.dateType.displayFormat || props.dateType.format;
    const { dateType, classes }  = props;
    const { DATETYPES } = appConstants;
    let Picker = "";
    let IconProps= {
        leftArrowIcon:<ArrowLeft/>,
        rightArrowIcon:<ArrowRight/>
    }
    if(props.dateType.type === DATETYPES.TIME.type){
        Picker = InlineTimePicker;
        IconProps = { ampm: false};
    }else if(props.dateType.type === DATETYPES.DATE.type){
        Picker = InlineDatePicker;
    }else {
        Picker = InlineDateTimePicker;
        IconProps = {
            ...IconProps,
            ampm: false,
            dateRangeIcon:<DateRange/>,
            timeIcon:<Time/>
        }
    }


    function getKeyboardIcon(params){
        if(props.dateType.type === DATETYPES.TIME.type){
            return <Time className={props.classes.iconColor} {...params}/>
        }
        return <DateRange className={props.classes.iconColor} {...params}/>
    }

    function onInputChange(event, updateDate){
       
        const updatedDate = parse(event.target.value,dateTypeFormat, new Date());
        if(isDateTimeValid(updatedDate)){
            updateDate(updatedDate);
        }
    }

    let startPicker = null;
    let endPicker = null;

    let containerClass = "";
    if(props.mode === "horizontal"){
        containerClass = classes.horizontalView
    } else if(dateType.type === DATETYPES.DATETIME.type){
        containerClass = classes.dateTimeContainer;
    } else if(dateType.type === DATETYPES.TIME.type) {
         containerClass = classes.timeContainer;
    }

    return (
        <div className={`theme-${props.theme.themeName} ${classes.container} ${containerClass}`}>
            <Picker
                keyboard
                clearable
                disableOpenOnEnter
                label="From"
                format={dateTypeFormat}
                placeholder={dateType.placeholder}
                {...IconProps}
                value={props.startDateTime}
                onChange={props.startDateChanged}
                onClear={props.startDateChanged}
                mask={dateType.inputMask}
                ref={node=> startPicker = node}
                FormHelperTextProps={{
                    classes:{
                        root: classes.helperText
                    }
                }}
                PopoverProps={{
                    disablePortal: true,
                }}
                InputLabelProps={{
                    classes:{
                        root: classes.labelProps,
                        shrink: classes.labelShrink,
                    }
                }}
                InputProps={{
                    endAdornment: (<InputAdornment position="end" classes={{root: classes.inputAdornment}}>
                                        {props.startDateTime ? <Clear style={{ color: props.theme.iconColor }} onClick={()=> props.startDateChanged(null)}/> : null}
                                        { getKeyboardIcon({onClick:(event)=> startPicker.open(event)}) }
                                    </InputAdornment>),
                    classes:{
                        root: classes.inputRoot,
                        input: classes.inputStyle,
                        focused: classes.inputFocus
                    },
                    inputRef: props.inputRef
                }}
                // classes={{
                //     popoverPaper: classes.paperStyle,
                // }}
                onInputChange={(event) => onInputChange(event,props.startDateChanged)}
                invalidDateMessage= {`Invalid ${dateType.type}`}
                minDateMessage={`${dateType.type} should be greater than 1900-01-01`} // default min and max dates
                maxDateMessage={`${dateType.type} should be lesser than 2100-01-01`}
            />
            <Picker
                keyboard
                clearable
                disableOpenOnEnter
                label="To"
                format={dateTypeFormat}
                placeholder={dateType.placeholder}
                {...IconProps}
                minDate={props.startDateTime}
                value={props.endDateTime}
                onChange={props.endDateChanged}
                onClear={props.endDateChanged}
                mask={dateType.inputMask}
                ref={node=> endPicker = node}
                FormHelperTextProps={{
                    classes:{
                        root: classes.helperText
                    }
                }}
                PopoverProps={{
                    disablePortal: true
                }}
                InputLabelProps={{
                    classes:{
                        root: props.classes.labelProps,
                        shrink: classes.labelShrink,
                    }
                }}
                InputProps={{
                    endAdornment: (<InputAdornment position="end" classes={{root: classes.inputAdornment}}>
                                        { props.endDateTime ? <Clear style={{color: props.theme.iconColor }} onClick={()=> props.endDateChanged(null)}/> : null}
                                        { getKeyboardIcon({onClick:(event)=> endPicker.open(event)}) }
                                   </InputAdornment>),
                    classes:{
                        root: props.classes.inputRoot,
                        input: props.classes.inputStyle,
                        focused: classes.inputFocus
                    }
                }}
                // classes={{
                //     popoverPaper: props.classes.paperStyle
                // }}
                onInputChange={(event) => onInputChange(event,props.endDateChanged)}
                invalidDateMessage	={`Invalid ${dateType.type}`}
                minDateMessage={`${dateType.type} should be greater than ${props.startDateTime ? format(props.startDateTime, dateTypeFormat): ""}`}
                maxDateMessage={`${dateType.type} should be lesser than 2100-01-01`} // default max
            />
        </div>
    )
}

export default compose(withTheme(styles), withStyles(styles))(DateTimeRange);